module.exports = __webpack_public_path__ + "img/arrow-down-active.5ee1b64b.svg";